import * as metaStateUtils from '../../../../store/util/metaStateUtils';


/**
 * @param state {object} Domain state
 * @param order {object} Loaded order
 * @return {object} Updated domain state
 */
export default (state, order) => {

    const defaultOrder = metaStateUtils.withDefaultMetaState(order);
    state.orders[order.id] = metaStateUtils.setIsLoaded(defaultOrder);

    return state;
};
